import { render, staticRenderFns } from "./sales-by-sales.vue?vue&type=template&id=45037169&scoped=true&"
import script from "./sales-by-sales.vue?vue&type=script&lang=js&"
export * from "./sales-by-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45037169",
  null
  
)

export default component.exports